import axios from "axios";
import FormData from "form-data"

const FileCreatAxios = (props) => {
  var gett = localStorage.getItem("isloggedIn");
  var customerNo = localStorage.getItem("customerNumber");
  var userId = localStorage.getItem("userId");
  var locales = localStorage.getItem("locales") === "en" ? "en-IN" : "pt-Br";
  let data = new FormData();
  let daughterdata = new FormData();
  let deliveryorderdata = new FormData();

  deliveryorderdata.append('delivery_order', props.payload.delivery_order)

  let goodsInvoiceData = new FormData();
  goodsInvoiceData.append('invoice_doc', props.payload.invoice_doc)

  let fileUploadData = new FormData();
  fileUploadData.append('file', props.payload.file)
  fileUploadData.append('doc_type', props.payload.doc_type)
  fileUploadData.append('doc_name', props.payload.doc_name)

  daughterdata.append('daughter_invoice', props.payload.daughter_invoice)
  // data.append('coa_certificate_of_analysis', props.payload.coa_certificate_of_analysis || '')
  data.append('di', props.payload.di || '')
  data.append('excel_request_for_collection', props.payload.excel_request_for_collection || '')
  data.append('exoneration', props.payload.exoneration || '')
  data.append('failure_extract', props.payload.failure_extract || '')
  if (props.payload.fispq_and_fe) {
    let file = props.payload.fispq_and_fe
    for (let index = 0; index < file.length; index++) {
      data.append('fispq_and_fe', file[index] || '')

    }
  }

  if (props.payload.coa_certificate_of_analysis) {
    let file = props.payload.coa_certificate_of_analysis
    for (let index = 0; index < file.length; index++) {
      data.append('coa_certificate_of_analysis', file[index] || '')

    }
  }
  data.append('inv_invoice', props.payload.inv_invoice || '')
  data.append('mother_invoice', props.payload.mother_invoice || '')
  data.append('original_bl', props.payload.original_bl || '')
  data.append('proof_of_id', props.payload.proof_of_id || '')
  data.append('packing_list', props.payload.packing_list || '')
  data.append('bd_shipment_database', props.payload.bd_shipment_database || '')
  if (props.daughterInviceURL) {
    var apiURL = props.daughterInviceURL
      ? `${props.daughterInviceURL}?customer_no=${customerNo}&user_id=${userId}`
      : `${props.url}?customer_no=${customerNo}&user_id=${userId}`;
  } else if (props.deliveryorderURL) {
    var apiURL = props.deliveryorderURL
      ? `${props.deliveryorderURL}?customer_no=${customerNo}&user_id=${userId}`
      : `${props.url}?customer_no=${customerNo}&user_id=${userId}`;
  }
  else if (props.goodsInvoiceURL) {
    var apiURL = props.goodsInvoiceURL
      ? `${props.goodsInvoiceURL}?customer_no=${customerNo}&user_id=${userId}`
      : `${props.url}?customer_no=${customerNo}&user_id=${userId}`;
  }
  else {
    var apiURL = props.completeURL
      ? `${props.completeURL}?customer_no=${customerNo}&user_id=${userId}`
      : `${props.url}?customer_no=${customerNo}&user_id=${userId}`;
  }

  if (props.completeURL) {
    try {
      return new Promise((resolve, reject) => {
        axios
          .post(apiURL, data, {
            headers: {
              Accept: "application/json",
              "Content-Type": "multipart/form-data",
              Authorization: `${gett}`,
              "Accept-Language": locales
            },
          })
          .then((res) => {
            console.log("axios component", res.data);
            resolve(res);
          })
          .catch((err) => {
            console.log("err", err);
            reject(err);
          });
      });
    } catch (error) {
      return console.log("Error Create", error);
    }
  }
  else if (props.daughterInviceURL) {
    try {
      return new Promise((resolve, reject) => {
        axios
          .put(apiURL, daughterdata, {
            headers: {
              Accept: "application/json",
              "Content-Type": "multipart/form-data",
              Authorization: `${gett}`,
              "Accept-Language": locales
            },
          })
          .then((res) => {
            console.log("axios component", res.data);
            if (res.status === 200) {
              resolve(res);
            } else {
              console.log("Error", res.data);
              reject(res);
            }
          })
          .catch((err) => {
            console.log("err", err);
            reject(err);
          });
      });
    } catch (error) {
      return console.log("Error Create", error);
    }
  } else if (props.deliveryorderURL) {
    try {
      return new Promise((resolve, reject) => {
        axios
          .put(apiURL, deliveryorderdata, {
            headers: {
              Accept: "application/json",
              "Content-Type": "multipart/form-data",
              Authorization: `${gett}`,
              "Accept-Language": locales
            },
          })
          .then((res) => {
            console.log("axios component", res.data);
            if (res.status === 200) {
              resolve(res);
            } else {
              console.log("Error", res.data);
              reject(res);
            }
          })
          .catch((err) => {
            console.log("err", err);
            reject(err);
          });
      });
    } catch (error) {
      return console.log("Error Create", error);
    }
  }
  else if (props.goodsInvoiceURL) {
    try {
      return new Promise((resolve, reject) => {
        var apiURLTemp = props.goodsInvoiceURL
          ? `${props.goodsInvoiceURL}`
          : `${props.url}`;


        axios
          .post(apiURL, goodsInvoiceData, {
            headers: {
              Accept: "application/json",
              "Content-Type": "multipart/form-data",
              Authorization: `${gett}`,
              "Accept-Language": locales
            },
          })
          .then((res) => {
            console.log("axios component", res.data);
            if (res.status === 200) {
              resolve(res);
            } else {
              console.log("Error", res.data);
              reject(res);
            }
          })
          .catch((err) => {
            console.log("err", err);
            reject(err);
          });
      });
    } catch (error) {
      return console.log("Error Create", error);
    }
  }
  else if (props.fileUploadURL) {
    try {
      return new Promise((resolve, reject) => {
        var apiURLCall = props.fileUploadURL
          ? `${props.fileUploadURL}`
          : `${props.url}`;

        axios
          .post(apiURLCall, fileUploadData, {
            headers: {
              Accept: "application/json",
              "Content-Type": "multipart/form-data",
              Authorization: `${gett}`,
              "Accept-Language": locales
            },
          })
          .then((res) => {
            console.log("axios component", res.data);
            if (res.status === 200) {
              resolve(res);
            } else {
              console.log("Error", res.data);
              reject(res);
            }
          })
          .catch((err) => {
            console.log("err", err);
            reject(err);
          });
      });
    } catch (error) {
      return console.log("Error Create", error);
    }
  }
  else {
    try {
      return new Promise((resolve, reject) => {
        axios
          .put(apiURL, data, {
            headers: {
              Accept: "application/json",
              "Content-Type": "multipart/form-data",
              Authorization: `${gett}`,
              "Accept-Language": locales
            },
          })
          .then((res) => {
            console.log("axios component", res.data);
            if (res.status === 200) {
              resolve(res);
            } else {
              console.log("Error", res.data);
              reject(res);
            }
          })
          .catch((err) => {
            console.log("err", err);
            reject(err);
          });
      });
    } catch (error) {
      return console.log("Error Create", error);
    }
  }
};



export default FileCreatAxios;
